"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.toggleSelection = exports.setSearchString = exports.setOrderByOptions = exports.setFilterOptions = exports.setOffset = exports.setLimit = exports.clearColumFilter = exports.filterColumns = exports.toggleRecentProjects = exports.toggleShowArchived = exports.toggleShowBookmarked = exports.clearFilters = exports.changeActiveView = exports.unbookmarkProjectFailure = exports.unbookmarkProjectSuccess = exports.unbookmarkProject = exports.bookmarkProjectFailure = exports.bookmarkProjectSuccess = exports.bookmarkProject = exports.createProjectMetadataFailure = exports.createProjectMetadataSuccess = exports.createProjectMetadata = exports.fetchProjectsFailure = exports.fetchProjectsSuccess = exports.fetchProjects = void 0;
const ActionTypes = require("../actionTypes/projects");
function fetchProjects(opts = {}) {
    return {
        type: ActionTypes.FETCH_PROJECTS_REQUEST,
        payload: opts
    };
}
exports.fetchProjects = fetchProjects;
function fetchProjectsSuccess(projects) {
    return {
        type: ActionTypes.FETCH_PROJECTS_SUCCESS,
        payload: projects
    };
}
exports.fetchProjectsSuccess = fetchProjectsSuccess;
function fetchProjectsFailure(error) {
    return {
        type: ActionTypes.FETCH_PROJECTS_FAILURE,
        payload: error
    };
}
exports.fetchProjectsFailure = fetchProjectsFailure;
function createProjectMetadata(data) {
    return {
        type: ActionTypes.CREATE_PROJECT_METADATA_REQUEST,
        payload: {
            data
        }
    };
}
exports.createProjectMetadata = createProjectMetadata;
function createProjectMetadataSuccess(data) {
    return {
        type: ActionTypes.CREATE_PROJECT_METADATA_SUCCESS,
        result: data
    };
}
exports.createProjectMetadataSuccess = createProjectMetadataSuccess;
function createProjectMetadataFailure(error) {
    return {
        type: ActionTypes.CREATE_PROJECT_METADATA_FAILURE,
        payload: error
    };
}
exports.createProjectMetadataFailure = createProjectMetadataFailure;
function bookmarkProject(id) {
    return {
        type: ActionTypes.BOOKMARK_PROJECT_REQUEST,
        payload: {
            id,
            bookmarked: true
        }
    };
}
exports.bookmarkProject = bookmarkProject;
function bookmarkProjectSuccess(data) {
    return {
        type: ActionTypes.BOOKMARK_PROJECT_SUCCESS,
        result: {
            data
        }
    };
}
exports.bookmarkProjectSuccess = bookmarkProjectSuccess;
function bookmarkProjectFailure(error) {
    return {
        type: ActionTypes.BOOKMARK_PROJECT_FAILURE,
        payload: error
    };
}
exports.bookmarkProjectFailure = bookmarkProjectFailure;
function unbookmarkProject(id) {
    return {
        type: ActionTypes.UNBOOKMARK_PROJECT_REQUEST,
        payload: {
            id,
            bookmarked: false
        }
    };
}
exports.unbookmarkProject = unbookmarkProject;
function unbookmarkProjectSuccess(data) {
    return {
        type: ActionTypes.UNBOOKMARK_PROJECT_SUCCESS,
        result: {
            data
        }
    };
}
exports.unbookmarkProjectSuccess = unbookmarkProjectSuccess;
function unbookmarkProjectFailure(error) {
    return {
        type: ActionTypes.UNBOOKMARK_PROJECT_FAILURE,
        payload: error
    };
}
exports.unbookmarkProjectFailure = unbookmarkProjectFailure;
function changeActiveView() {
    return {
        type: ActionTypes.CHANGE_ACTIVE_VIEW
    };
}
exports.changeActiveView = changeActiveView;
function clearFilters() {
    return {
        type: ActionTypes.CLEAR_FILTERS
    };
}
exports.clearFilters = clearFilters;
function toggleShowBookmarked() {
    return {
        type: ActionTypes.TOGGLE_SHOW_BOOKMARKS
    };
}
exports.toggleShowBookmarked = toggleShowBookmarked;
function toggleShowArchived() {
    return {
        type: ActionTypes.TOGGLE_SHOW_ARCHIVED
    };
}
exports.toggleShowArchived = toggleShowArchived;
function toggleRecentProjects() {
    return {
        type: ActionTypes.TOGGLE_RECENT_PROJECTS
    };
}
exports.toggleRecentProjects = toggleRecentProjects;
function filterColumns(identifier, filter) {
    return {
        type: ActionTypes.FILTER_COLUMNS,
        payload: {
            identifier,
            filter
        }
    };
}
exports.filterColumns = filterColumns;
function clearColumFilter(identifier) {
    return {
        type: ActionTypes.CLEAR_COLUMN_FILTER,
        payload: {
            identifier
        }
    };
}
exports.clearColumFilter = clearColumFilter;
function setLimit(limit) {
    return {
        type: ActionTypes.SET_LIMIT,
        payload: limit
    };
}
exports.setLimit = setLimit;
function setOffset(offset) {
    return {
        type: ActionTypes.SET_OFFSET,
        payload: offset
    };
}
exports.setOffset = setOffset;
function setFilterOptions(filter, value) {
    return {
        type: ActionTypes.SET_FILTER_OPTIONS,
        payload: {
            filter,
            value
        }
    };
}
exports.setFilterOptions = setFilterOptions;
function setOrderByOptions(orderBy, order) {
    return {
        type: ActionTypes.SET_ORDER_BY_OPTIONS,
        payload: {
            orderBy,
            order
        }
    };
}
exports.setOrderByOptions = setOrderByOptions;
function setSearchString(searchString) {
    return {
        type: ActionTypes.SET_SEARCH_STRING,
        payload: searchString
    };
}
exports.setSearchString = setSearchString;
function toggleSelection(project) {
    return {
        type: ActionTypes.TOGGLE_SELECTION,
        payload: project
    };
}
exports.toggleSelection = toggleSelection;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
//# sourceMappingURL=projects.js.map